<template>
  <div>
    <img :src="skk_captcha.image_url" alt="" @click="handleReCaptcha()" />
  </div>
</template>

<script>
// import { getCaptchaImage, getHomeCompanyInfo } from "@/api/index.js";
import { getCaptchaImage } from "@/api/index.js";

export default {
  name: "imgVerify",
  data() {
    return {
      skk_captcha: {
        session: "",
        image_url: "",
      },
      temp_image_url: "",
    };
  },
  async created() {
    this.init();
    // skk_get_home_info
    // const res = await getHomeCompanyInfo({ id: 1 });
    // console.log(res);
  },
  methods: {
    async init() {
      const res = await getCaptchaImage();
      const { session } = res;
      const { image_url } = res;
      this.skk_captcha = {
        session,
        image_url: `${image_url}?session=${session}`,
      };
      this.temp_image_url = `${image_url}?session=${session}`;
      this.$store.dispatch("skkSetImgCaptchaSession", res.session);
    },
    handleReCaptcha() {
      this.skk_captcha.image_url = `${this.temp_image_url}&t=${Date.now()}`;
    },
  },
};
</script>

<style lang="less" scoped>
img {
  width: 100%;
  height: 40px;
}
</style>
